// // src/socket.js
// import io from 'socket.io-client';

// const socket = io(process.env.REACT_APP_SOCKET_API_URL);

// export default socket;


// src/socket.js

let socket = null;

function createWebSocket() {
    const ws = new WebSocket('wss://api.brokercheap.com:8000/ws?symbols=all');
    return ws;
}

export { socket, createWebSocket };
